<script>
    import { version } from "../../package.json";

</script>

<footer>
    <a href="#/contact">🚀 הצטרפות</a>
    <a href="#/eula">תנאי שימוש</a>
    <span class="version">{version}</span>
</footer>

<style>
    footer {
        width: 100%;
        background: #e7e7e7;
        padding: 18px;
        box-sizing: border-box;
        direction: rtl;
        display: flex;
        gap: 18px;
        font-size: 14px;
        align-items: baseline;
    }

    .version {
        margin-right: auto;
    }

</style>
